// libs
import React, { memo } from "react";

// global components
import WithStyles from "shared/components/WithStyles";
import Logo from "shared/components/Logo";
import Internationalization from "shared/components/Internationalization";

// components
import HeaderApi from "shared/components/Header/HeaderApi";
import Menu from "./components/Menu";
import Search from "./components/Search";
import Auth from "./components/Auth";
import Cart from "./components/Cart";
import PromotionalBanner from "./components/PromotionalBanner";

// constants
import { urls, ROUTES } from "shared/api/urls";

// styles
import { headerBlockStyle, headerCss } from "./styles";

const LOGO_HEIGHT = 38;
const LOGO_WIDTH = 80;

function Header() {
    return (
        <>
            <HeaderApi>
                <WithStyles as="header" cssProps={headerCss}>
                    <PromotionalBanner />
                    <WithStyles className="top-header" cssProps={headerBlockStyle}>
                        <div className="header-logo">
                            <a aria-label="Home" href={urls[ROUTES.HOME]}>
                                <Logo
                                    className="header-logo-svg"
                                    height={LOGO_HEIGHT}
                                    width={LOGO_WIDTH}
                                />
                            </a>
                        </div>
                        <div className="header-categories">
                            <Menu />
                        </div>
                        <ul className="header-actions">
                            <li className="action">
                                <Search />
                            </li>
                            <li className="action">
                                <Auth />
                            </li>
                            <li className="action">
                                <Cart />
                            </li>
                        </ul>
                    </WithStyles>
                </WithStyles>
            </HeaderApi>
            <Internationalization />
        </>
    );
}

export default memo(Header);
